import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/App.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/shared/Login';
import Navigation from './components/shared/Navigation';
import Footer from './components/shared/Footer';
import CustomerPortal from './components/customer/CustomerPortal';
import AdminPortal from './components/admin/AdminPortal';
import DashboardPortal from './components/admin/DashboardPortal';
import { Spinner, Container } from 'react-bootstrap';

function AppContent() {
  const { isAuthenticated, isAdmin, isDashboard, loading } = useAuth();

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Loading...</p>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return (
      <>
        <Login />
        <Footer />
      </>
    );
  }

  return (
    <div className="app-container">
      <Navigation />
      <div className="main-content">
        {isAdmin ? <AdminPortal /> : isDashboard ? <DashboardPortal /> : <CustomerPortal />}
      </div>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
